import {
  Badge,
  Button,
  Card,
  Checkbox,
  Dropdown,
  Image,
  Tag,
  Tooltip,
} from 'antd';
import { isEmpty } from 'lodash';
import React from 'react';
import Countdown from 'react-countdown';
import { ReactComponent as CommentIcon } from '../../../../../assets/svg/comment-dots-solid.svg';
import { ReactComponent as MoreIcon } from '../../../../../assets/svg/ellipsis-vertical-solid.svg';
import {
  CANCELLATION_TYPE,
  DATE_FORMATS,
  DELIVERY_TYPE,
  FIRST_ORDER_FLAG,
  FULFILLMENT_STATUS,
  LIBRARY_ALL_DELIVERY_TABLE_ACTIONS_OPTIONS,
  NEW_ORDER_TABLE_ACTIONS_OPTIONS,
  ORDER_STATUS,
  USER_ROLES,
} from '../../../../../common/constants';
import {
  formatDate,
  getRowClassName,
  renderer,
} from '../../../../../common/utils';
import UserSelect from '../../../../../modules/payments/modules/endUser/components/UserSelect';

const AllOrderCard = ({
  thresholdData,
  order,
  infiniteScrollRef,
  handleOrderChange,
  setOrder,
  setIsAllOrderItemModalOpen,
  isNewPath,
  setIsNotePrompts,
  setIsOrderAction,
  handleChallanDownload,
  isChallanLoading,
  handleChallanReset,
  isResetLoading,
  setVisible,
  setToyImages,
  handleSelectOrders,
  selectedOrders,
  setIsReasonPrompt,
  isAdmin,
  isAssignDelPartnerTab,
  setDeliveryPartnerData,
  setIsDeliveryPartnerPrompts,
  isCombinedOrder,
  hasUpdatePermission,
  setIsAddCommentModalOpen,
  setIsOrderStatusModalOpen,
  playNotificationSound,
  criticalOrdersRef,
  isAllDelivery,
  isLibrary,
}) => {
  const handleMenuClick = (e) => {
    handleOrderChange(e?.key, order);
  };

  let selectedValue = null;
  if (
    order?.status === ORDER_STATUS?.CANCELLED?.value ||
    order?.status === ORDER_STATUS?.CONFIRMED?.value
  ) {
    if (order?.status === ORDER_STATUS?.CANCELLED?.value) {
      selectedValue = FULFILLMENT_STATUS?.UNFULFILLED?.value;
    } else {
      selectedValue = FULFILLMENT_STATUS?.FULFILLED?.value;
    }
  } else {
    selectedValue = null;
  }

  const setMenuProps = () => {
    if (isNewPath) {
      return {
        items: NEW_ORDER_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
        })),
        onClick: handleMenuClick,
        disabled: !!selectedValue,
      };
      // eslint-disable-next-line no-else-return
    } else {
      return {
        items: LIBRARY_ALL_DELIVERY_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
        })),
        onClick: handleMenuClick,
        disabled:
          order?.status === ORDER_STATUS?.CANCELLED?.value ||
          order?.status === ORDER_STATUS?.DELIVERED?.value ||
          order?.status === ORDER_STATUS?.SHIPPED?.value ||
          order?.status === ORDER_STATUS?.NOT_DELIVERED?.value,
      };
    }
  };

  const { firstName, lastName, id, userNumber } = order?.deliveryPartner || {};
  const assignedDeliveryPartner = {
    firstName,
    lastName,
    id,
    userNumber,
  };

  const menuProps = isNewPath
    ? {
        items: NEW_ORDER_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
        })),
        onClick: handleMenuClick,
        disabled: !!selectedValue,
      }
    : {
        items: LIBRARY_ALL_DELIVERY_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
        })),
        onClick: handleMenuClick,
        disabled:
          order?.status === ORDER_STATUS?.CANCELLED?.value ||
          order?.status === ORDER_STATUS?.DELIVERED?.value ||
          order?.status === ORDER_STATUS?.SHIPPED?.value ||
          order?.status === ORDER_STATUS?.NOT_DELIVERED?.value,
      };

  const shippedAttachments =
    order?.deliveryAttachments?.filter(
      (attachment) =>
        attachment?.deliveryAttachmentsType === ORDER_STATUS?.SHIPPED?.value,
    ) || [];

  const deliveredAttachments =
    order?.deliveryAttachments?.filter((attachment) =>
      [ORDER_STATUS?.DELIVERED?.value, null]?.includes(
        attachment?.deliveryAttachmentsType,
      ),
    ) || [];

  const isCheckboxDisabled = () => {
    if (isAdmin) {
      if (isAssignDelPartnerTab) {
        return false;
      }
      return (
        order?.status === ORDER_STATUS?.CANCELLED?.value ||
        order?.status === ORDER_STATUS?.CONFIRMED?.value ||
        order?.delayedInConfirmed
      );
    }
    // eslint-disable-next-line no-else-return
    else {
      return ![
        ORDER_STATUS?.READY_TO_SHIP?.value,
        ORDER_STATUS?.SHIPPED?.value,
        ORDER_STATUS?.CONFIRMED?.value,
        ORDER_STATUS?.DELIVERED?.value,
        ORDER_STATUS?.NOT_DELIVERED?.value,
      ]?.includes(order?.status);
    }
  };

  const nextStatusTime = new Date(order?.nextStatusTime)?.getTime();
  const userData = order?.user;

  return (
    <Card
      className={`ml-12 mr-12 mb-24 mt-12 mobile-card ${getRowClassName(
        order,
        thresholdData,
        playNotificationSound,
        criticalOrdersRef,
      )}`}
      title={
        <div className="overflow-scroll no-scroll-bar align-center">
          {(isAdmin || !isNewPath) && !isCombinedOrder && !isAllDelivery && (
            <Checkbox
              className="mr-12"
              onClick={(e) => e.stopPropagation()}
              disabled={isCheckboxDisabled()}
              checked={selectedOrders?.includes(order?.id)}
              onChange={(e) => {
                e.stopPropagation();
                handleSelectOrders(order?.id);
              }}
            />
          )}
          {order?.orderNumber}{' '}
        </div>
      }
      extra={
        <div className="d-flex align-center">
          <Badge
            color={ORDER_STATUS?.[order?.status]?.color}
            text={ORDER_STATUS?.[order?.status]?.text}
            className="mr-16 ml-16"
          />
          {!isAssignDelPartnerTab && (isAdmin ? isNewPath : true) && (
            <>
              <span>
                {order?.cancellationData?.type ===
                  CANCELLATION_TYPE?.LIBRARY?.value && (
                  <span className="action-button">
                    <CommentIcon
                      className="mr-16 pointer svg-icon"
                      onClick={(e) => {
                        e?.stopPropagation();
                        setIsNotePrompts(true);
                        setOrder(order);
                        setIsOrderAction(true);
                      }}
                    />
                  </span>
                )}
              </span>
              <div onClick={(e) => e?.stopPropagation()} className="d-flex">
                <Dropdown
                  getPopupContainer={(trigger) => trigger?.parentNode}
                  menu={setMenuProps()}
                  disabled={
                    order.transferOrderItemCount !== 0 &&
                    order.transferOrderItemCount !== null
                  }
                >
                  <MoreIcon
                    className="pointer mobile-svg-icon"
                    onClick={(e) => {
                      e?.stopPropagation();
                    }}
                  />
                </Dropdown>
              </div>
            </>
          )}
        </div>
      }
      ref={infiniteScrollRef}
      onClick={() => {
        setOrder(order);
        setIsAllOrderItemModalOpen(true);
      }}
    >
      <div>
        <div className="mb-8">
          <span className="mobile-card-label">Quantity: </span>
          <span>{order?.orderItemCount || 'No Quantity'}</span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">Total Orders Count: </span>
          <span>{order?.totalOrdersCount ?? 'No Total Orders Count'}</span>
        </div>

        {!isCombinedOrder && !isAssignDelPartnerTab && (
          <>
            <div className="mb-8">
              <span className="mobile-card-label">
                {isNewPath ? 'Order Packaging SLA:' : 'Order SLA:'}{' '}
              </span>
              <span>
                {order?.nextStatusTime
                  ? formatDate(order?.nextStatusTime, DATE_FORMATS?.WITH_TIME)
                  : 'N/A'}
              </span>
            </div>
            <div className="mb-8">
              <span className="mobile-card-label">
                {isNewPath ? 'Order Packaging Time Left:' : 'Order Time Left:'}{' '}
              </span>
              <span>
                <div>
                  {!isEmpty(order?.nextStatusTime) &&
                  (!isNewPath
                    ? order?.status !== ORDER_STATUS?.DELIVERED?.value
                    : true) ? (
                    <Countdown date={nextStatusTime} renderer={renderer} />
                  ) : (
                    'N/A'
                  )}
                </div>
              </span>
            </div>
          </>
        )}

        {!isCombinedOrder && isAssignDelPartnerTab && (
          <>
            <div className="mb-8">
              <span className="mobile-card-label">
                {order?.status === ORDER_STATUS.CONFIRMED.value
                  ? 'Rider Assignment SLA: '
                  : 'Delivery SLA: '}
              </span>
              <span>
                {order?.nextStatusTime
                  ? formatDate(order?.nextStatusTime, DATE_FORMATS?.WITH_TIME)
                  : 'N/A'}
              </span>
            </div>
            <div className="mb-8">
              <span className="mobile-card-label">
                {order?.status === ORDER_STATUS.CONFIRMED.value
                  ? 'Rider Assignment Time Left: '
                  : 'Delivery Time Left: '}
              </span>
              <span>
                <div>
                  {!isEmpty(order?.nextStatusTime) &&
                  (!isNewPath
                    ? order?.status !== ORDER_STATUS?.DELIVERED?.value
                    : true) ? (
                    <Countdown date={nextStatusTime} renderer={renderer} />
                  ) : (
                    'N/A'
                  )}
                </div>
              </span>
            </div>
          </>
        )}

        <div className="mb-8">
          <span className="mobile-card-label">Delivery Type: </span>
          <span>
            {DELIVERY_TYPE?.[order?.deliveryType]?.label || 'No Delivery Type'}
          </span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label">User ID: </span>
          <>
            {userData?.firstName || userData?.lastName ? (
              <div className="table-data-with-id">{`${
                userData?.firstName ? userData?.firstName : ''
              } ${userData?.lastName ? userData?.lastName : ''}`}</div>
            ) : (
              '-'
            )}
            {userData?.userNumber ? (
              <div className="font-size-12">({userData?.userNumber})</div>
            ) : (
              ''
            )}
          </>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">Pincode: </span>
          <span>{order?.pincode?.pincode || 'No Pincode'}</span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label">Is First Order: </span>
          <span>
            {' '}
            {order?.isFirstOrder ? (
              <Tag color="green">{FIRST_ORDER_FLAG}</Tag>
            ) : (
              'No'
            )}
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">Is Delayed Order: </span>
          <span>
            {' '}
            {order?.delayedInConfirmed || order?.delayedInShipped ? (
              <Tag color="red" className="">
                {order?.delayedInShipped ? 'Delayed in Shipment' : 'Delayed'}
              </Tag>
            ) : (
              'No'
            )}
          </span>
        </div>

        {!isAssignDelPartnerTab && (
          <div className="mb-8">
            <span className="mobile-card-label">Delay Reason: </span>
            <span>
              <div className="action-button">
                {!isEmpty(order?.metadata) ? (
                  <Tooltip title="View reason" placement="top" zIndex={4}>
                    <CommentIcon
                      className="mr-16 pointer svg-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsReasonPrompt(true);
                        setOrder(order);
                        setIsOrderAction(true);
                      }}
                    />
                  </Tooltip>
                ) : (
                  <span className="mr-24">-</span>
                )}
              </div>
            </span>
          </div>
        )}

        <div className="mb-8">
          <span className="mobile-card-label">Delivery Partner Name: </span>
          <span>
            {order?.deliveryPartner?.firstName ||
            order?.deliveryPartner?.lastName ? (
              <span className="table-data-with-id">{`${
                order?.deliveryPartner?.firstName
                  ? order?.deliveryPartner?.firstName
                  : ''
              } ${
                order?.deliveryPartner?.lastName
                  ? order?.deliveryPartner?.lastName
                  : ''
              }`}</span>
            ) : (
              'No Delivery Partner'
            )}
            {order?.deliveryPartner?.userNumber ? (
              <span className="font-size-12">
                ({order?.deliveryPartner?.userNumber})
              </span>
            ) : (
              ''
            )}
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">Placed On: </span>
          <span>{formatDate(order?.createdAt, DATE_FORMATS?.WITH_TIME)}</span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label">
            {isNewPath ? 'Estimated Shipping Date:' : 'Delivered On:'}{' '}
          </span>
          <span>
            {formatDate(order?.deliveredOn, DATE_FORMATS?.WITH_TIME) || '-'}
          </span>
        </div>

        {!isNewPath && (
          <>
            <div className="mb-8">
              <span className="mobile-card-label">Shipped Attachments: </span>
              <span>
                {shippedAttachments?.length > 0 ? (
                  <Image
                    preview={{
                      visible: false,
                    }}
                    width={20}
                    height={20}
                    src={shippedAttachments?.[0]?.url}
                    onClick={(e) => {
                      e?.stopPropagation();
                      setVisible(true);
                      setToyImages(shippedAttachments);
                    }}
                    className="pointer"
                  />
                ) : (
                  <span>No Images</span>
                )}
                {shippedAttachments?.length > 1
                  ? ` + ${shippedAttachments?.length - 1}`
                  : ''}
              </span>
            </div>
            <div className="mb-8">
              <span className="mobile-card-label">Delivered Attachments: </span>
              <span>
                {deliveredAttachments?.length > 0 ? (
                  <Image
                    preview={{
                      visible: false,
                    }}
                    width={20}
                    height={20}
                    src={deliveredAttachments?.[0]?.url}
                    onClick={(e) => {
                      e?.stopPropagation();
                      setVisible(true);
                      setToyImages(deliveredAttachments);
                    }}
                    className="pointer"
                  />
                ) : (
                  <span>No Images</span>
                )}
                {deliveredAttachments?.length > 1
                  ? ` + ${deliveredAttachments?.length - 1}`
                  : ''}
              </span>
            </div>
          </>
        )}

        {isAssignDelPartnerTab && (
          <>
            <div className="dashed-line" />
            <div onClick={(e) => e?.stopPropagation()}>
              <UserSelect
                isLibrary={isLibrary}
                size="small"
                className="user-select"
                placeholder="Select Delivery Partner"
                showAction={['click']}
                value={id || null}
                userData={id ? assignedDeliveryPartner : null}
                roles={USER_ROLES?.DELIVERY?.key}
                onChange={(value, user) => {
                  setOrder(order);
                  setDeliveryPartnerData(user);
                  setIsDeliveryPartnerPrompts(true);
                }}
                allowClear={false}
              />
            </div>
          </>
        )}
        {!isNewPath && !isAdmin && !isAssignDelPartnerTab && (
          <>
            <div className="dashed-line" />
            <div className="d-flex justify-between flex-wrap gap-10">
              <Button
                type="primary"
                className="mr-16"
                loading={isChallanLoading?.[order?.id]}
                onClick={(e) => {
                  e?.stopPropagation();
                  // eslint-disable-next-line no-undef
                  const windowReference = window.open();
                  handleChallanDownload(order?.id, windowReference);
                }}
                disabled={
                  ![
                    ORDER_STATUS?.READY_TO_SHIP?.value,
                    ORDER_STATUS?.SHIPPED?.value,
                    ORDER_STATUS?.CONFIRMED?.value,
                    ORDER_STATUS?.DELIVERED?.value,
                    ORDER_STATUS?.NOT_DELIVERED?.value,
                  ]?.includes(order?.status)
                }
              >
                Download Challan
              </Button>
              <Button
                loading={isResetLoading?.[order?.id]}
                onClick={(e) => {
                  e?.stopPropagation();
                  handleChallanReset(order?.id);
                }}
                disabled={
                  ![
                    ORDER_STATUS?.READY_TO_SHIP?.value,
                    ORDER_STATUS?.CONFIRMED?.value,
                  ]?.includes(order?.status)
                }
              >
                Reset Challan
              </Button>
            </div>
          </>
        )}

        {isAdmin && !isNewPath && !isAssignDelPartnerTab && (
          <>
            <div className="dashed-line" />
            <div
              className="d-flex justify-between flex-wrap gap-10"
              onClick={(e) => e.stopPropagation()}
            >
              {hasUpdatePermission && (
                <Button
                  type="primary"
                  size="small"
                  className="custom-buttons"
                  onClick={(e) => {
                    e?.stopPropagation();
                    setIsAddCommentModalOpen(true);
                    setOrder(order);
                    setIsOrderAction(true);
                  }}
                  disabled={
                    order?.status === ORDER_STATUS?.DELIVERED?.value ||
                    order?.status === ORDER_STATUS?.CANCELLED?.value
                  }
                >
                  Cancel
                </Button>
              )}
              <Button
                type="primary"
                className="custom-buttons"
                size="small"
                onClick={() => {
                  // eslint-disable-next-line no-undef
                  const windowReference = window.open();
                  handleChallanDownload(order?.id, windowReference);
                }}
                loading={isChallanLoading?.[order?.id]}
                disabled={
                  ![
                    ORDER_STATUS?.READY_TO_SHIP?.value,
                    ORDER_STATUS?.SHIPPED?.value,
                    ORDER_STATUS?.CONFIRMED?.value,
                    ORDER_STATUS?.DELIVERED?.value,
                    ORDER_STATUS?.NOT_DELIVERED?.value,
                  ]?.includes(order?.status)
                }
              >
                Download Challan
              </Button>
              <Button
                type="primary"
                size="small"
                className="custom-buttons"
                onClick={() => handleChallanReset(order?.id)}
                loading={isResetLoading?.[order?.id]}
                disabled={
                  ![
                    ORDER_STATUS?.READY_TO_SHIP?.value,
                    ORDER_STATUS?.CONFIRMED?.value,
                  ]?.includes(order?.status)
                }
              >
                Reset Challan
              </Button>

              <Button
                type="primary"
                size="small"
                className="custom-buttons"
                onClick={() => {
                  setOrder(order);
                  setIsOrderAction(true);
                  setIsOrderStatusModalOpen(true);
                }}
              >
                Order Status Logs
              </Button>
            </div>
          </>
        )}
      </div>
    </Card>
  );
};

export default AllOrderCard;
